export default "__VITE_ASSET__CuiU5dDA__"